module.exports = __webpack_public_path__ + "070c5f9edbdfd151950961c495099883.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/images/small/postinternet-definition.jpg
 ** module id = 412
 ** module chunks = 0
 **/